import { takeLatest, put } from 'redux-saga/effects'
import { OverlayToaster, Position } from '@blueprintjs/core';

import { createReducer, makeAction, makeKeys } from './reduxHelpers'

let AppToaster = OverlayToaster.create({
  className: "recipe-toaster",
  position: Position.TOP,
});

const APP_LOADING = 'APP_LOADING'
const APP_LOADED = 'APP_LOADED'
const TOAST_SUCCESS = 'TOAST_SUCCESS'
const TOAST_WARNING = 'TOAST_WARNING'
const TOAST_ERROR = 'TOAST_ERROR'
const TOAST_CLEAR = 'TOAST_CLEAR'
const MENU_SELECTED = makeKeys('MENU_SELECTED')

export const appLoading = makeAction(APP_LOADING, 'message')
export const appLoaded = makeAction(APP_LOADED)
export const toastSuccess = makeAction(TOAST_SUCCESS, 'message')
export const toastWarning = makeAction(TOAST_WARNING, 'message')
export const toastError = makeAction(TOAST_ERROR, 'message')
export const toastClear = makeAction(TOAST_CLEAR)
export const setMenuSeleted = makeAction(MENU_SELECTED.REQUEST)

const menuSeletedSuccess = makeAction(MENU_SELECTED.SUCCESS, 'data')

function* showSuccessToast(action) {
  AppToaster.clear()
  yield AppToaster.show({ message: action.payload.message, intent: 'success', timeout: 5000 })
}

function* showWarningToast(action) {
  AppToaster.clear()
  yield AppToaster.show({ message: action.payload.message, intent: 'warning', timeout: 15000 })
}

function* showErrorToast(action) {
  yield AppToaster.show({ message: action.payload.message, intent: 'danger', timeout: 0 })
}

function* clearToast() {
  AppToaster.clear()
}
function* showMenuSeleted(action) {
  yield put(menuSeletedSuccess(action.payload))
}
export function* watchApplicationSaga() {
  yield takeLatest(TOAST_SUCCESS, showSuccessToast)
  yield takeLatest(TOAST_WARNING, showWarningToast)
  yield takeLatest(TOAST_ERROR, showErrorToast)
  yield takeLatest(TOAST_CLEAR, clearToast)
  yield takeLatest(MENU_SELECTED.REQUEST, showMenuSeleted)
}

const initial = {
  appLoading: { message: '', loading: false },
  menuSeleted: ""
}

export default createReducer(initial, state => ({
  [APP_LOADING]: (payload) => ({
    ...state,
    appLoading: { message: payload.message || 'Loading...', loading: true }
  }),
  [APP_LOADED]: () => ({
    ...state,
    appLoading: { message: '', loading: false }
  }),
  [MENU_SELECTED.REQUEST]: () => ({
    ...state,
    menuSeleted: ""
  }),
  [MENU_SELECTED.SUCCESS]: (payload) => ({
    ...state,
    menuSeleted: payload.data
  }),
}))